import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.SAVE_TEMP_DATA] (state, { id, data }) {
    console.log('mutaion', types.SAVE_TEMP_DATA, data, id)
    Vue.set(state, id, data)
    console.log('mutaion done', state)
  },
  [types.LOAD_TEMP_DATA] (state) {

  }
}
